import React, { useEffect, useState } from 'react';
import {
	getBuddyStats,
	getCheckInFrequencyStats,
	getCourseStats,
	getOnboardingActivityStats,
	getOverallScoreStats,
	getSleepScoreStats,
	getStrategyStats,
	getStrugglesStats,
} from '../../server/server';
import { useChartData } from './UseChartData';
import OnboardingBarChart from './OnboardingBarChart';
import { overallList, sleepList } from './OnboardingConstants';

function OnboardingAnalyticsHome() {
	const buddyData: any = useChartData(getBuddyStats);
	const overallData: any = useChartData(getOverallScoreStats);
	const struggleData: any = useChartData(getStrugglesStats);
	const checkInFrequencyData: any = useChartData(getCheckInFrequencyStats);
	const activityData: any = useChartData(getOnboardingActivityStats);
	const sleepScoreData: any = useChartData(getSleepScoreStats);
	const strategyData: any = useChartData(getStrategyStats);
	const courseData: any = useChartData(getCourseStats);
	return (
		<div id='scroll-inf-task' className='flex h-screen flex-col items-center overflow-y-auto bg-[#ECEBF8] py-[10px]'>
			<div className=' w-full  max-w-[1200px] px-[10px]'>
				<div className='w-full min-h-[calc(100vh-20px)]  bg-white flex flex-col px-[40px] py-[30px] rounded-[6px]'>
					<div className='flex flex-col gap-7'>
						<p className='text-gray900 font-bold text-[24px] leading-7 '>Onboarding Analytics</p>

						<OnboardingBarChart data={buddyData.data} loading={buddyData.loading} yAxelText='Number of selected buddies' />
						<OnboardingBarChart data={overallData.data} loading={overallData.loading} yAxelText='Number of selected overall' list={overallList} />
						<OnboardingBarChart data={struggleData.data} loading={struggleData.loading} yAxelText='Number of selected struggles' />
						<OnboardingBarChart data={checkInFrequencyData.data} loading={checkInFrequencyData.loading} yAxelText='Number of selected check in' />
						<OnboardingBarChart data={activityData.data} loading={activityData.loading} yAxelText='Number of selected activities' />
						<OnboardingBarChart data={sleepScoreData.data} loading={sleepScoreData.loading} yAxelText='Number of selected sleep score' list={sleepList} />
						<OnboardingBarChart data={strategyData.data} loading={strategyData.loading} yAxelText='Number of selected strategies' />
						<OnboardingBarChart data={courseData.data} loading={courseData.loading} yAxelText='Number of selected courses' />
					</div>
				</div>
			</div>
		</div>
	);
}

export default OnboardingAnalyticsHome;
